// extracted by mini-css-extract-plugin
module.exports = {"root":"H1_root__ATpLP"};